<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="normal"></app-breadcrumb>

<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Relatórios de Servidores
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Gere relatórios dos dados dos servidores. Utilize os filtros para criar uma visualização específica e em seguida exporte o relatório desejado. Se preferir, rapidamente exporte o modelo padrão.
        </p>
      </div>
    </div>

    <form novalidate>
      <div class="form-row">
        <div class="col-6">
          <div class="form-group">
            <div class="controls">
              <label for="municipio" style="font-weight: bold">MUNICÍPIO</label>
              <ng-select
                [items]="cidades"
                name="municipio"
                placeholder="Selecione o Município"
                id="municipio"
                bindLabel="nome"
                bindValue="id"
                (change)="changeCidade($event)"
                [(ngModel)]="cidadeEscolhida"
                [clearable]="false"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="controls">
              <label for="tipoRelatorio" style="font-weight: bold">TIPO DE RELATÓRIO</label>
              <ng-select
                [items]="tipos"
                name="tipos"
                placeholder="Selecione o Tipo de Relatório"
                id="tipos"
                bindLabel="descricao"
                bindValue="id"
                (change)="alternarRelatorio()"
                [(ngModel)]="statusRelatorio"
                [disabled]="desabilitaRelatorio"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-6" *ngIf="statusRelatorio == '14'">
          <div class="form-group">
            <div class="controls">
              <label for="statusServidor" style="font-weight: bold">STATUS DO SERVIDOR</label>
              <ng-select
                [items]="statusServidorOpcoes"
                name="statusServidor"
                placeholder="Selecione o Status"
                id="statusServidor"
                bindLabel="descricao"
                bindValue="id"
                [(ngModel)]="statusServidorProvaVida"
                [clearable]="false"
                [disabled]="desabilitaRelatorio"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col-6" *ngIf="statusRelatorio == '1'">
          <div class="form-group">
            <div class="controls">
              <label for="sexo" style="font-weight: bold">Sexo</label>
              <ng-select
                [items]="sexos"
                name="sexo"
                bindLabel="name"
                placeholder="Selecione o sexo"
                bindValue="id"
                id="sexo"
                (change)="pesquisarPorSexo()"
                [(ngModel)]="sexo"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col-6" *ngIf="statusRelatorio == '2'">
          <div class="form-group">
            <div class="controls">
              <label for="idade" style="font-weight: bold">Idade</label>
              <input
                type="text"
                id="idade"
                class="form-control"
                [(ngModel)]="idade"
                (change)="pesquisarPorIdade()"
                mask="9*"
                name="idade"
                placeholder="Digite a idade"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col-6" *ngIf="statusRelatorio == '3'">
          <div class="form-group">
            <div class="controls">
              <label for="quantidade_dependente" style="font-weight: bold">Quantidade Dependentes</label>
              <input
                type="text"
                id="quantidade_dependente"
                class="form-control"
                [(ngModel)]="quantidade_dependente"
                (change)="pesquisarPorQuantidadeDependentes()"
                mask="9*"
                name="quantidade_dependente"
                placeholder="Digite a quantidade"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="form-row" *ngIf="statusRelatorio == '4'">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="tempoMinimo" style="font-weight: bold">Tempo de Serviço</label>
              <div class="d-flex">
                <input
                  type="text"
                  id="tempoMinimo"
                  class="form-control"
                  [(ngModel)]="tempoMinimo"
                  (change)="pesquisarPorTempoMinimo()"
                  mask="9*"
                  name="tempoMinimo"
                  placeholder="Mínimo (Dias)"
                  required
                  aria-invalid="false"
                />
                <span class="mx-2 d-flex align-items-center">até</span>
                <input
                  type="text"
                  id="tempoMaximo"
                  class="form-control"
                  [(ngModel)]="tempoMaximo"
                  (change)="pesquisarPorTempoMaximo()"
                  mask="9*"
                  name="tempoMaximo"
                  placeholder="Máximo (Dias)"
                  required
                  aria-invalid="false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row" *ngIf="statusRelatorio == '5'">
        <div class="col">
          <div class="form-group">
            <label for="dataNascimento" style="font-weight: bold">Data de Nascimento</label>
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="text"
                  id="dataNascimentoMinima"
                  class="form-control"
                  [(ngModel)]="dataNascimentoMinima"
                  (change)="pesquisarPorDataNascimentoMinimoDatePicker()"
                  [dropSpecialCharacters]="false"
                  mask="00/00/0000"
                  name="dataNascimentoMinima"
                  placeholder="dd/mm/yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="text"
                  id="dataNascimentoMaxima"
                  class="form-control"
                  [(ngModel)]="dataNascimentoMaxima"
                  (change)="pesquisarPorDataNascimentoMaximoDatePicker()"
                  [dropSpecialCharacters]="false"
                  mask="00/00/0000"
                  name="dataNascimentoMaxima"
                  placeholder="dd/mm/yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row" *ngIf="statusRelatorio == '6'">
        <div class="col">
          <div class="form-group">
            <label for="dataNascimentoDependente" style="font-weight: bold">Data de Nascimento Dependentes</label>
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="text"
                  id="dataNascimentoDependenteMinima"
                  class="form-control"
                  [(ngModel)]="dataNascimentoDependenteMinima"
                  (change)="pesquisarPorDataNascimentoDependenteMinimoDatePicker()"
                  [dropSpecialCharacters]="false"
                  mask="00/00/0000"
                  name="dataNascimentoDependenteMinima"
                  placeholder="dd/mm/yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="text"
                  id="dataNascimentoDependenteMaxima"
                  class="form-control"
                  [(ngModel)]="dataNascimentoDependenteMaxima"
                  (change)="pesquisarPorDataNascimentoDependenteMaximoDatePicker()"
                  [dropSpecialCharacters]="false"
                  mask="00/00/0000"
                  name="dataNascimentoDependenteMaxima"
                  placeholder="dd/mm/yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <hr class="my-4">

    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary mr-2"
          [disabled]="desabilitaRelatorio"
          (click)="gerarRelatorioSPREV()"
        >
          <i class="fa fa-file-excel-o mr-2"></i>SPREV
        </button>
      </div>
      <div class="col-auto" *ngIf="statusRelatorio == '14'">
        <button
          type="button"
          class="btn btn-success mr-2"
          [disabled]="desabilitaRelatorio || !statusServidorProvaVida || provaVidaEmAndamento"
          (click)="gerarProvaDeVida()"
        >
          <i class="fa fa-heartbeat mr-2"></i>Gerar prova de vida
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary mr-2"
          [disabled]="this.servidoresModeloPadraoFiltered.length == 0 || desabilitaRelatorio"
          (click)="gerarModeloPadrao()"
        >
          <i class="fa fa-file-text-o mr-2"></i>Modelo Padrão
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="getDisabledState()"
          (click)="gerarRelatorio()"
        >
          <i class="fa fa-download mr-2"></i>Gerar Relatório
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Tabela para Servidores -->
<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio != '7' && statusRelatorio != '8' && statusRelatorio != '9' && statusRelatorio != '10' && statusRelatorio != '11' && statusRelatorio != '12' && statusRelatorio != '13' && statusRelatorio != '15' && servidores.length > 0">
  <table class="table text-center" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Nome
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('data_nascimento')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Data de Nascimento
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('data_nascimento')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('data_nascimento')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('data_nascimento')"
                class="fa"
                [ngClass]="getSortIcon('data_nascimento')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('sexo')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Sexo
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('sexo')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('sexo')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('sexo')"
                class="fa"
                [ngClass]="getSortIcon('sexo')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('ativo')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Ativo
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('ativo')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('ativo')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('ativo')"
                class="fa"
                [ngClass]="getSortIcon('ativo')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('nome_conferidor')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Conferidor
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome_conferidor')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome_conferidor')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome_conferidor')"
                class="fa"
                [ngClass]="getSortIcon('nome_conferidor')"
              ></i>
            </div>
          </div>
        </th>
        <th>
          <div class="d-flex align-items-center justify-content-center">
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="
          let servidor of servidoresFiltered
            | slice
              : (page - 1) * pageSize
              : (page - 1) * pageSize + pageSize
        "
      >
        <td class="pl-3 pr-3 align-middle">
          <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
            {{ servidor.nome }}
          </div>
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ servidor.data_nascimento }}
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ servidor.sexo === "M" ? "MASCULINO" : "FEMININO" }}
        </td>
        <td class="text-center align-middle">
          <span
            class="badge"
            [style.background-color]="servidor.ativo ? '#28a745' : '#dc3545'"
            [style.color]="'white'"
            style="font-size: 16px;">
            {{ servidor.ativo ? "SIM" : "NÃO" }}
          </span>
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ servidor.nome_conferidor || '-' }}
        </td>
        <td class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-outline-primary"
            [routerLink]="['/page/servidorv2']"
            [queryParams]="{ id: servidor.id }"
          >
            <i class="fa fa-external-link mr-2"></i>Visualizar
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  
  <!-- Paginação dos servidores -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="servidoresFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="servidoresFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<!-- Tabela para Dependentes -->
<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio == '7' && dependentes.length > 0">
  <div class="table-responsive">
    <table class="table text-center" style="padding: 10px; font-size: 16px;">
      <thead>
        <tr>
          <th>Nome do Titular</th>
          <th>CPF do Titular</th>
          <th>Matrícula do Titular</th>
          <th>Tipo de Dependência</th>
          <th>Motivo</th>
          <th>Nome do Dependente</th>
          <th>Sexo do Dependente</th>
          <th>Nome da Mãe</th>
          <th>Nome do Pai</th>
          <th>Nascimento</th>
          <th>Estado Civil</th>
          <th>Naturalizado</th>
          <th>UF Naturalidade</th>
          <th>Cidade Naturalidade</th>
          <th>Nacionalidade</th>
          <th>Escolaridade</th>
          <th>Deficiente</th>
          <th>CPF Do Dependente</th>
          <th>CEP</th>
          <th>Tipo Logradouro</th>
          <th>Logradouro</th>
          <th>Número</th>
          <th>Bairro</th>
          <th>Complemento</th>
          <th>Telefone</th>
          <th>Celular</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dependente of dependentesFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <td class="texto-linha-tabela">{{ dependente.nome_titular }}</td>
          <td class="texto-linha-tabela">{{ dependente.cpf_titular }}</td>
          <td class="texto-linha-tabela">{{ dependente.matricula_titular }}</td>
          <td class="texto-linha-tabela">{{ dependente.tipo_dependencia }}</td>
          <td class="texto-linha-tabela">{{ dependente.motivo }}</td>
          <td class="texto-linha-tabela">{{ dependente.nome_dependente }}</td>
          <td class="texto-linha-tabela">{{ dependente.sexo_dependente }}</td>
          <td class="texto-linha-tabela">{{ dependente.nome_mae }}</td>
          <td class="texto-linha-tabela">{{ dependente.nome_pai }}</td>
          <td class="texto-linha-tabela">{{ dependente.nascimento }}</td>
          <td class="texto-linha-tabela">{{ dependente.estado_civil }}</td>
          <td class="texto-linha-tabela">{{ dependente.naturalizado }}</td>
          <td class="texto-linha-tabela">{{ dependente.uf_naturalidade }}</td>
          <td class="texto-linha-tabela">{{ dependente.cidade_naturalidade }}</td>
          <td class="texto-linha-tabela">{{ dependente.nacionalidade }}</td>
          <td class="texto-linha-tabela">{{ dependente.escolaridade }}</td>
          <td class="texto-linha-tabela">{{ dependente.deficiente }}</td>
          <td class="texto-linha-tabela">{{ dependente.cpf_dependente }}</td>
          <td class="texto-linha-tabela">{{ dependente.cep }}</td>
          <td class="texto-linha-tabela">{{ dependente.tipo_logradouro }}</td>
          <td class="texto-linha-tabela">{{ dependente.logradouro }}</td>
          <td class="texto-linha-tabela">{{ dependente.numero }}</td>
          <td class="texto-linha-tabela">{{ dependente.bairro }}</td>
          <td class="texto-linha-tabela">{{ dependente.complemento }}</td>
          <td class="texto-linha-tabela">{{ dependente.telefone }}</td>
          <td class="texto-linha-tabela">{{ dependente.celular }}</td>
          <td class="texto-linha-tabela">{{ dependente.email }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <!-- Paginação dos dependentes -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="dependentesFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="dependentesFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<!-- Tabela para Lista de Tempo de Serviço -->
<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio == '8' && temposServico.length > 0">
  <div class="table-responsive">
    <table class="table text-center" style="padding: 10px; font-size: 16px;">
      <thead>
        <tr>
          <th>Nome do Titular</th>
          <th>CPF do Titular</th>
          <th>Matrícula do Titular</th>
          <th>Seq</th>
          <th>CNPJ</th>
          <th>Empregador</th>
          <th>Data Inicial</th>
          <th>Data Final</th>
          <th>Tempo em Dias</th>
          <th>TIPO</th>
          <th>Tempo em Sala de Aula</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tempo of temposServicoFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <td class="texto-linha-tabela">{{ tempo.nome_titular }}</td>
          <td class="texto-linha-tabela">{{ tempo.cpf_titular }}</td>
          <td class="texto-linha-tabela">{{ tempo.matricula_titular }}</td>
          <td class="texto-linha-tabela">{{ tempo.seq }}</td>
          <td class="texto-linha-tabela">{{ tempo.cnpj }}</td>
          <td class="texto-linha-tabela">{{ tempo.empregador }}</td>
          <td class="texto-linha-tabela">{{ tempo.data_inicial }}</td>
          <td class="texto-linha-tabela">{{ tempo.data_final }}</td>
          <td class="texto-linha-tabela">{{ tempo.tempo_em_dias }}</td>
          <td class="texto-linha-tabela">{{ tempo.tipo }}</td>
          <td class="texto-linha-tabela">{{ padronizarSimNao(tempo.tempo_em_sala_aula || tempo.tempo_em_sala_de_aula) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <!-- Paginação dos tempos de serviço -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="temposServicoFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="temposServicoFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<!-- Tabela para Total de Tempo de Serviço por Servidor -->
<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio == '9' && servidoresComTotais.length > 0">
  <div class="table-responsive">
    <table class="table text-center" style="padding: 10px; font-size: 16px;">
      <thead>
        <tr>
          <th>Nome do Titular</th>
          <th>CPF do Titular</th>
          <th>Matrícula do Titular</th>
          <th>Status</th>
          <th>Tempo TOTAL em Dias</th>
          <th>Tempo TOTAL em Dias - Em sala de Aula</th>
          <th>Tempo TOTAL em Dias - NÃO Em sala de Aula</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let servidor of servidoresComTotaisFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <td class="texto-linha-tabela">{{ servidor.nome_titular }}</td>
          <td class="texto-linha-tabela">{{ servidor.cpf_titular }}</td>
          <td class="texto-linha-tabela">{{ servidor.matricula_titular }}</td>
          <td class="texto-linha-tabela">{{ servidor.status || 'Não informado' }}</td>
          <td class="texto-linha-tabela">{{ servidor.tempo_total_em_dias || 0 }}</td>
          <td class="texto-linha-tabela">{{ servidor.tempo_total_em_sala_de_aula || 0 }}</td>
          <td class="texto-linha-tabela">{{ servidor.tempo_total_nao_em_sala_de_aula || 0 }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <!-- Paginação dos servidores com totais -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="servidoresComTotaisFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="servidoresComTotaisFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<!-- Tabela para Listagem Geral -->
<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio == '10' && listagemGeral.length > 0">
  <div class="table-responsive">
    <table class="table text-center" style="padding: 10px; font-size: 16px;">
      <thead>
        <tr>
          <th>Nome do Titular</th>
          <th>Status</th>
          <th>Sexo</th>
          <th>Data Nascimento</th>
          <th>Estado Civil</th>
          <th>Nome da Mãe</th>
          <th>Nome do Pai</th>
          <th>Nacionalidade</th>
          <th>Naturalizado</th>
          <th>Estado</th>
          <th>Cidade</th>
          <th>Escolaridade</th>
          <th>PCD</th>
          <th>Órgão</th>
          <th>CEP</th>
          <th>Tipo do Logradouro</th>
          <th>Logradouro</th>
          <th>Número</th>
          <th>Bairro</th>
          <th>Complemento</th>
          <th>CPF</th>
          <th>RG</th>
          <th>Emissão</th>
          <th>Órgão Expedidor</th>
          <th>UF RG</th>
          <th>PIS</th>
          <th>Telefone</th>
          <th>Celular</th>
          <th>Email</th>
          <th>Matrícula</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let servidor of listagemGeralFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <td class="texto-linha-tabela">{{ servidor['Nome do Titular'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Status'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Sexo'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Data Nascimento'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Estado Civil'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Nome da Mãe'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Nome do Pai'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Nacionalidade'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Naturalizado'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Estado'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Cidade'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Escolaridade'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['PCD'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Órgão'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['CEP'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Tipo do Logradouro'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Logradouro'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Número'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Bairro'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Complemento'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['CPF'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['RG'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Emissão'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Órgão Expedidor'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['UF RG'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['PIS'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Telefone'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Celular'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Email'] }}</td>
          <td class="texto-linha-tabela">{{ servidor['Matrícula'] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <!-- Paginação da listagem geral -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="listagemGeralFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="listagemGeralFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<!-- Tabela para Servidores com Múltiplas Matrículas -->
<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio == '11' && multiplasMatriculas.length > 0">
  <div class="table-responsive">
    <table class="table text-center" style="padding: 10px; font-size: 16px;">
      <thead>
        <tr>
          <th (click)="sortTable('Matrícula do Titular')" class="cursor-pointer">
            <div class="d-flex align-items-center justify-content-center">
              Matrícula do Titular
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('Matrícula do Titular')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('Matrícula do Titular')" class="fa fa-caret-down"></i>
                <i
                  *ngIf="isColumnSorted('Matrícula do Titular')"
                  class="fa"
                  [ngClass]="getSortIcon('Matrícula do Titular')"
                ></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('Status')" class="cursor-pointer">
            <div class="d-flex align-items-center justify-content-center">
              Status
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('Status')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('Status')" class="fa fa-caret-down"></i>
                <i
                  *ngIf="isColumnSorted('Status')"
                  class="fa"
                  [ngClass]="getSortIcon('Status')"
                ></i>

              </div>
            </div>
          </th>
          <th (click)="sortTable('Nome')" class="cursor-pointer">
            <div class="d-flex align-items-center justify-content-center">
              Nome
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('Nome')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('Nome')" class="fa fa-caret-down"></i>
                <i
                  *ngIf="isColumnSorted('Nome')"
                  class="fa"
                  [ngClass]="getSortIcon('Nome')"
                ></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('CPF do Titular')" class="cursor-pointer">
            <div class="d-flex align-items-center justify-content-center">
              CPF do Titular
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('CPF do Titular')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('CPF do Titular')" class="fa fa-caret-down"></i>
                <i
                  *ngIf="isColumnSorted('CPF do Titular')"
                  class="fa"
                  [ngClass]="getSortIcon('CPF do Titular')"
                ></i>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let servidor of multiplasMatriculasFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <td class="texto-linha-tabela" style="font-size: 16px;">{{ servidor['Matrícula do Titular'] }}</td>
          <td class="texto-linha-tabela" style="font-size: 16px;">{{ servidor['Status'] }}</td>
          <td class="texto-linha-tabela" style="font-size: 16px;">{{ servidor['Nome'] }}</td>
          <td class="texto-linha-tabela" style="font-size: 16px;">{{ servidor['CPF do Titular'] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <!-- Paginação dos servidores com múltiplas matrículas -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="multiplasMatriculasFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="multiplasMatriculasFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<!-- Tabela para Atendimentos -->
<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio == '12' && atendimentos.length > 0">
  <div class="table-responsive">
    <table class="table text-center table-striped" style="padding: 10px; font-size: 14px;">
      <thead>
        <tr>
          <th (click)="sortTable('nome')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Nome
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('nome')" class="fa" [ngClass]="getSortIcon('nome')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('cpf')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              CPF
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('cpf')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('cpf')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('cpf')" class="fa" [ngClass]="getSortIcon('cpf')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('matricula')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Matrícula
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('matricula')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('matricula')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('matricula')" class="fa" [ngClass]="getSortIcon('matricula')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('status')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Status
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('status')" class="fa" [ngClass]="getSortIcon('status')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('data_inicio_atendimento')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Data Início
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('data_inicio_atendimento')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('data_inicio_atendimento')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('data_inicio_atendimento')" class="fa" [ngClass]="getSortIcon('data_inicio_atendimento')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('hora_inicio_atendimento')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Hora Início
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('hora_inicio_atendimento')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('hora_inicio_atendimento')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('hora_inicio_atendimento')" class="fa" [ngClass]="getSortIcon('hora_inicio_atendimento')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('data_fim_atendimento')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Data Fim
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('data_fim_atendimento')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('data_fim_atendimento')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('data_fim_atendimento')" class="fa" [ngClass]="getSortIcon('data_fim_atendimento')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('hora_fim_atendimento')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Hora Fim
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('hora_fim_atendimento')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('hora_fim_atendimento')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('hora_fim_atendimento')" class="fa" [ngClass]="getSortIcon('hora_fim_atendimento')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('atendimento_realizado')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Atendimento
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('atendimento_realizado')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('atendimento_realizado')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('atendimento_realizado')" class="fa" [ngClass]="getSortIcon('atendimento_realizado')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('cidade')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Cidade
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('cidade')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('cidade')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('cidade')" class="fa" [ngClass]="getSortIcon('cidade')"></i>
              </div>
            </div>
          </th>
          <th (click)="sortTable('local_trabalho')" class="cursor-pointer" style="white-space: nowrap;">
            <div class="d-flex align-items-center justify-content-center">
              Local de Trabalho
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('local_trabalho')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('local_trabalho')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('local_trabalho')" class="fa" [ngClass]="getSortIcon('local_trabalho')"></i>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let atendimento of atendimentosFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.nome }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.cpf }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.matricula }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.status }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.data_inicio_atendimento }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.hora_inicio_atendimento }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.data_fim_atendimento }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.hora_fim_atendimento }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.atendimento_realizado }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.cidade }}</td>
          <td class="texto-linha-tabela" style="white-space: nowrap;">{{ atendimento.local_trabalho }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <!-- Paginação dos atendimentos -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="atendimentosFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="atendimentosFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<!-- Tabela para Arquivos do Servidor -->
<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio == '13' && arquivosServidores.length > 0">
  <div class="table-responsive">
    <table class="table text-center" style="padding: 10px; font-size: 16px;">
      <thead>
        <tr>
          <th (click)="sortTable('nome')" class="cursor-pointer">
            <div class="d-flex align-items-center justify-content-center">
              Nome
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('nome')" class="fa" [ngClass]="getSortIcon('nome')"></i>
              </div>
            </div>
          </th>
          <th>CPF</th>
          <th>RG</th>
          <th>Matrícula</th>
          <th>Arquivo</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let servidor of arquivosServidoresFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <td class="texto-linha-tabela align-middle">{{ servidor.nome }}</td>
          <td class="texto-linha-tabela align-middle">{{ servidor.cpf }}</td>
          <td class="texto-linha-tabela align-middle">{{ servidor.rg }}</td>
          <td class="texto-linha-tabela align-middle">{{ servidor.matricula }}</td>
          <td class="texto-linha-tabela text-left">{{ servidor.arquivo }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginação dos arquivos -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="arquivosServidoresFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="arquivosServidoresFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<!-- Tabela para Pendências -->

<div class="card" style="border-radius: 10px" *ngIf="statusRelatorio == '15' && pendencias.length > 0">
  <div class="table-responsive">
    <table class="table text-center" style="padding: 10px; font-size: 16px;">
      <thead>
        <tr>
          <th (click)="sortTable('nome_titular')" class="cursor-pointer">
            <div class="d-flex align-items-center justify-content-center">
              Nome
              <div class="sort-icons ml-1">
                <i *ngIf="!isColumnSorted('nome_titular')" class="fa fa-caret-up"></i>
                <i *ngIf="!isColumnSorted('nome_titular')" class="fa fa-caret-down"></i>
                <i *ngIf="isColumnSorted('nome_titular')" class="fa" [ngClass]="getSortIcon('nome_titular')"></i>
              </div>
            </div>
          </th>

          <th>CPF</th>
          <th>Matrícula</th>
          <th>Status</th>
          <th>Pendência</th>
          <th>Observação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let servidor of pendenciasFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
          <td class="texto-linha-tabela align-middle">{{ servidor.nome_titular }}</td>
          <td class="texto-linha-tabela align-middle">{{ servidor.cpf_titular }}</td>
          <td class="texto-linha-tabela align-middle">{{ servidor.matricula_titular }}</td>
          <td class="texto-linha-tabela align-middle">{{ servidor.status }}</td>
          <td class="texto-linha-tabela text-left">{{ servidor.pendencias }}</td>
          <td class="texto-linha-tabela text-left">{{ servidor.observacoes }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginação das pendências -->

  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="pendenciasFiltered.length > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="pendenciasFiltered.length"
    ></ngb-pagination>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="getEmptyState()">
  <div class="card-body">
    <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
      <div class="text-center">
        <i class="fa fa-search" style="font-size: 48px; color: #6c757d; margin-bottom: 20px;"></i>
        <h5 class="mt-0" style="color: #6c757d;">{{ getEmptyMessage() }}</h5>
        <p style="color: #6c757d;">Selecione um tipo de relatório e configure os filtros para visualizar os dados.</p>
      </div>
    </div>
  </div>
</div>

<!-- Overlay de progresso da Prova de Vida (lote a lote) -->
<div
  *ngIf="provaVidaEmAndamento"
  class="d-flex justify-content-center align-items-center"
  style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); z-index: 99999;"
>
  <div class="text-center text-white" style="max-width: 480px; width: 90%;">
    <i class="fa fa-heartbeat fa-3x mb-3" style="color: #28a745;"></i>
    <h4 class="text-white">Gerando prova de vida...</h4>
    <p class="mb-2">
      Processando {{ provaVidaProcessados }} de {{ provaVidaTotal }}
      <span *ngIf="provaVidaTotalPaginas">
        (lote {{ provaVidaPaginaAtual }} de {{ provaVidaTotalPaginas }})
      </span>
    </p>
    <div class="progress" style="height: 22px;">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated bg-success"
        role="progressbar"
        [style.width.%]="provaVidaPercentual()"
        [attr.aria-valuenow]="provaVidaPercentual()"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ provaVidaPercentual() }}%
      </div>
    </div>
    <p class="mt-3 mb-0" style="font-weight: bold; color: #ffc107;">
      <i class="fa fa-exclamation-triangle mr-1"></i>
      Não feche nem saia desta página enquanto o processamento estiver em andamento.
    </p>
  </div>
</div>

<ngx-spinner></ngx-spinner>
